export const restartApp = () => {
  return {
    type: "RESTART_APP"
  };
};



// WEBPACK FOOTER //
// ./src/actions/appRestart.actions.js